import filter from 'lodash/filter';
import has from 'lodash/has';
import head from 'lodash/head';
import sortBy from 'lodash/sortBy';

import TargetDividendTypeEnum from '@constants/enums/targetDividendType';
import TaxStatusEnum from '@constants/enums/taxStatus';

import { toPercentage } from '@utils/number';

import clock from '@plugins/dayjs';
import i18n from '@plugins/i18n';

export const findNextOfferEvent = offer => {
    let events = [];

    if (has(offer, 'open_at')) {
        events.push({
            name: i18n.t('open_at'),
            date: offer.open_at
        });
    }

    if (has(offer, 'close_at')) {
        events.push({
            name: i18n.t('close_at'),
            date: offer.close_at
        });
    }

    if (has(offer, 'existing_investor_close_at')) {
        events.push({
            name: i18n.t('existing_investor_close_at'),
            date: offer.existing_investor_close_at
        });
    }

    if (has(offer, 'early_bird_close_at')) {
        events.push({
            name: i18n.t('early_bird_close_at'),
            date: offer.early_bird_close_at
        });
    }

    if (has(offer, 'next_allotment_at')) {
        events.push({
            name: i18n.t('next_allotment_at'),
            date: offer.next_allotment_at
        });
    }

    events = filter(events, event => {
        const date = clock(event.date);
        return date.isValid() && date.isAfter(clock());
    });

    events = sortBy(events, event => {
        return clock(event.date).valueOf();
    });

    return head(events);
};

export const getTaxReliefPercentage = taxStatus => {
    switch (taxStatus) {
        case TaxStatusEnum.EIS:
        case TaxStatusEnum.VCT:
            return 0.3;
        case TaxStatusEnum.SEIS:
            return 0.5;
        default:
            return 0;
    }
};

export const getTaxRelief = (taxStatus, amount = 0) => {
    amount = parseFloat(amount);

    if (isNaN(amount)) {
        return 0;
    }

    return amount * getTaxReliefPercentage(taxStatus);
};

/**
 * Return the target dividend string
 * @param {Number} value
 * @param {String} type
 */
export const getTargetDividend = (type, value) => {
    if (value === null || value === undefined) {
        return null;
    }

    if (type === TargetDividendTypeEnum.YIELD) {
        return `${toPercentage(value)} yield per annum`;
    } else if (type === TargetDividendTypeEnum.ABSOLUTE) {
        return `${value}${i18n.t('p_per_share')}`;
    }

    return null;
};
